import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-29/task-01";

const task: Slide = {
  titleHtml:
    "In the solutions proposed below, choose the ones that<br>could be used  to create sound zones in the horizontal plane.",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
